// @ts-ignore
import React from "react";

import { css } from "@compiled/react";

import Spinner from "@atlaskit/spinner";

import { LOADING_STATE_TEST_ID } from "../../utils/perceived-provisioning/constants";

const loadingStyle = css({
    position: "fixed",
    insetBlockStart: "50%",
    insetInlineStart: "50%",
    transform: "translate(-50%, -50%)"
});

export const LoadingState = () => (
    <div css={loadingStyle} data-testid={LOADING_STATE_TEST_ID}>
        <Spinner size="large" />
    </div>
);
